<div class="new-content" *ngIf="!pane else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <ng-template [ngIf]="!pane?.infinity" [ngIfElse]="infinity">
    <div class="collections-drag-scroll">
      <div class="pane-header" [class.mobile]="deviceService.isMobile()">
      <app-library-title [title]="blockTitleCollections" [class.with-sorting]="_pane.show_sorting"></app-library-title>
      <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitleCollections?.see_all_link" [pane]="_pane"></app-library-sorting>
      </div>

      <ng-template [ngIf]="isDragScrollEnabled && isBrowser" [ngIfElse]="responsiveScroll">
        <div class="carousel">
          <ng-template [ngIf]="collections.length >= 3">
            <div class="right-btn" (click)="moveRight()">
              <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
            </div>

            <div class="left-btn" (click)="moveLeft()">
              <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
            </div>
          </ng-template>

          <cdk-virtual-scroll-viewport #scroller [itemSize]="itemSize" class="scroll-viewport" orientation="horizontal">
            <div *cdkVirtualFor="let collection of collections; let i = index; trackBy: trackContentByFn"
                 class="scroll-item">
              <app-collection-card-mini [collection]="collection"
                                        [displayMode]="'infinity'"
                                        [linkEnable]="false"
                                        (action)="onAction()"
                                        (openInModal)="onOpenCard($event)">
              </app-collection-card-mini>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-template>

      <ng-template #responsiveScroll>
        <div class="responsive-scroll-viewport">
          <div *ngFor="let collection of collections; let i = index; trackBy: trackContentByFn"
               class="scroll-item">
            <app-collection-card-mini [collection]="collection"
                                      [linkEnable]="false"
                                      (action)="onAction()"
                                      (openInModal)="onOpenCard($event)">
            </app-collection-card-mini>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #infinity>
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title [title]="blockTitleCollections" [class.with-sorting]="_pane.show_sorting"></app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitleCollections?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <div class="infinity-collection-cards">
      <div *ngFor="let collection of collections; let i = index; trackBy: trackContentByFn" class="infinity-item">
        <app-collection-card-mini [collection]="collection"
                                  [linkEnable]="false"
                                  (action)="onAction()"
                                  (openInModal)="onOpenCard($event)">
        </app-collection-card-mini>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>
  </ng-template>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           (closed)="onCloseCard()">
  <app-modal-body>
    <article rel="main">
      <app-collection-card [collection]="item" [meta]="true" (isCloseAllModals)="onCloseCard()"></app-collection-card>
    </article>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal"
                  (closed)="onCloseCard()">
  <app-mobile-modal-title>{{ 'collections.collection' | customLocale }}</app-mobile-modal-title>

  <app-mobile-modal-body>
    <article rel="main">
      <app-collection-card [collection]="item" [meta]="true"></app-collection-card>
    </article>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
